var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 20.375H33.125",
    stroke: "#2C3B60",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 27H33.125",
    stroke: "#2C3B60",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 33.625H26.5",
    stroke: "#2C3B60",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4418 45.2187H9.9375C9.49824 45.2187 9.07696 45.0443 8.76635 44.7336C8.45575 44.423 8.28125 44.0018 8.28125 43.5625V10.4375C8.28125 9.99824 8.45575 9.57696 8.76635 9.26635C9.07696 8.95575 9.49824 8.78125 9.9375 8.78125H43.0625C43.5018 8.78125 43.923 8.95575 44.2336 9.26635C44.5443 9.57696 44.7187 9.99824 44.7187 10.4375V32.9418C44.7195 33.1569 44.6778 33.37 44.5961 33.5689C44.5144 33.7678 44.3943 33.9487 44.2426 34.1012L33.6012 44.7426C33.4487 44.8943 33.2678 45.0144 33.0689 45.0961C32.87 45.1778 32.6569 45.2195 32.4418 45.2187V45.2187Z",
    stroke: "#2C3B60",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5738 33.625H33.125V45.0738",
    stroke: "#2C3B60",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightNote);
export default __webpack_public_path__ + "static/media/LightNote.49f89a43539804fd7a0da3fed6ebbfb1.svg";
export { ForwardRef as ReactComponent };